// extracted by mini-css-extract-plugin
export default {"toolsBody":"Heatmaps_toolsBody__2Bx1c","section":"Heatmaps_section__Fo27t"};